import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { EwentsTooltipDirective } from '@ewentscompany/ewents-components';
import { Router, RouterModule } from '@angular/router';

import { LoginService, User } from '../../auth/login.service';
import { AvatarComponent } from '@ewentscompany/ewents-components';
import { MenuSearchComponent } from '../menu-search/menu-search.component';
import { NotificationBellComponent } from '../notification-bell/notification-bell.component';

interface BreadcrumbItem {
  label: string;
  route: string;
  isHome?: boolean;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    EwentsTooltipDirective,
    RouterModule,
    AvatarComponent,
    MenuSearchComponent,
    NotificationBellComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @Input() breadcrumbs: BreadcrumbItem[] = [];
  @Input() isHandset = false;
  /** Same gate as sidebar (2FA): hide menu search until the user can navigate. */
  @Input() showMenuSearch = false;
  /** Same gate as the Wenty FAB (`wenty:use` + 2FA). */
  @Input() showSupport = false;
  @Output() breadcrumbClick = new EventEmitter<string>();
  @Output() openSupport = new EventEmitter<void>();

  @ViewChild(MenuSearchComponent) private menuSearch?: MenuSearchComponent;

  currentUser: User | null = null;
  menuSearchOpen = false;

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.loginService.getCurrentUser$().subscribe(user => {
      this.currentUser = user;
    });

    if (this.loginService.isAuthenticated() && !this.loginService.getUser()) {
      this.loginService.fetchCurrentUser().subscribe({
        next: user => {
          this.currentUser = user;
        },
      });
    }
  }

  onBreadcrumbClick(breadcrumb: BreadcrumbItem): void {
    this.breadcrumbClick.emit(breadcrumb.route);
    this.router.navigate([breadcrumb.route]);
  }

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  openMenuSearch(): void {
    this.menuSearch?.openFromUi();
  }

  getDisplayName(): string {
    if (!this.currentUser) {
      return 'Usuario';
    }

    return `${this.currentUser.firstName} ${this.currentUser.lastName}`;
  }

  openSupportTicket(): void {
    if (!this.showSupport) return;
    this.openSupport.emit();
  }
}
